/**
 * Constants cho trang Lakehouse Data Sources
 */
export const SOURCE_TYPES = [
    {
        id: 'mongodb',
        label: 'MongoDB',
        description: 'NoSQL document database. Kết nối qua URI hoặc host/port/database.',
        icon: 'Storage', // MUI icon name
        color: '#00C853'
    },
    {
        id: 'postgres',
        label: 'PostgreSQL',
        description: 'Relational database. Cần host, port, database, user và password.',
        icon: 'Storage',
        color: '#2196F3'
    },
    {
        id: 'minio',
        label: 'MinIO',
        description: 'S3-compatible object storage. Endpoint, access key, secret key, bucket.',
        icon: 'Storage',
        color: '#FF9800'
    },
  {
    id: 'firebase',
    label: 'Firebase',
    description: 'Firestore hoặc Realtime Database. Firestore: chỉ cần Credentials (service account JSON). Realtime DB: thêm Database URL.',
    icon: 'Storage',
    color: '#9C27B0'
  }
];

export const DEFAULT_CONFIG = {
    mongodb: { uri: '', host: 'localhost', port: 27017, database: 'admin', username: '', password: '' },
    postgres: { host: 'localhost', port: 5432, database: 'postgres', user: '', password: '' },
    minio: { endpoint: 'localhost:9000', access_key: '', secret_key: '', bucket: '', secure: true },
    firebase: { databaseURL: '', credentials_json: null, credentials_path: '' }
};

export const MASKED_PLACEHOLDER = '••••••••';

/** Mã mẫu Python kết nối theo từng loại nguồn — hiển thị trong form Thêm/Sửa */
export const PYTHON_SAMPLES = {
    mongodb: `# pip install pymongo
from pymongo import MongoClient

# Cách 1: URI
uri = "mongodb://user:password@host:27017/database?authSource=admin"
client = MongoClient(uri)
db = client["database_name"]
for doc in db["my_collection"].find().limit(10):
    print(doc)
client.close()

# Cách 2: Từng trường
client = MongoClient(
    host="localhost", port=27017,
    username="user", password="password"
)
db = client["database_name"]`,

    postgres: `# pip install psycopg2-binary
import psycopg2
from psycopg2.extras import RealDictCursor

# Cách 1: URI
conn = psycopg2.connect("postgresql://user:password@host:5432/database")
cur = conn.cursor(cursor_factory=RealDictCursor)
cur.execute('SELECT * FROM "my_table" LIMIT 10')
for row in cur.fetchall():
    print(dict(row))
cur.close(); conn.close()

# Cách 2: Từng trường
conn = psycopg2.connect(
    host="localhost", port=5432, database="mydb",
    user="user", password="password"
)`,

    minio: `# pip install minio
from minio import Minio

client = Minio(
    "localhost:9000",
    access_key="your_access_key",
    secret_key="your_secret_key",
    secure=False  # True nếu dùng HTTPS
)
# Liệt kê buckets
for b in client.list_buckets():
    print(b.name)
# Liệt kê object trong bucket
for obj in client.list_objects("my-bucket", prefix="data/"):
    print(obj.object_name, obj.size)`,

    firebase: null // Dùng getFirebaseSampleCode(config) để lấy mã mẫu theo credentials thực tế
};

/**
 * Lấy mã mẫu Python cho Firebase/Firestore theo config user đã nhập.
 * Dùng đúng credentials đã input khi thêm nguồn: gợi ý lưu nội dung JSON đó vào file và trỏ script tới file đó.
 */
export function getFirebaseSampleCode(config) {
    const credPath = config?.credentials_path?.trim();
    let suggestedPath = credPath || 'credentials/firebase-service-account.json';
    const credJson = config?.credentials_json;
    if (!credPath && credJson && typeof credJson === 'object' && credJson.project_id) {
        suggestedPath = `credentials/${credJson.project_id}-firebase-adminsdk.json`;
    }
    const pathForCode = suggestedPath.replace(/\\/g, '/');
    return `# === SỬ DỤNG CREDENTIALS ĐÃ NHẬP KHI THÊM NGUỒN FIREBASE ===
# Bạn đã nhập Credentials (JSON) trong form thêm nguồn. Để chạy script Python:
# 1. Copy toàn bộ nội dung JSON từ ô Credentials (hoặc file bạn đã dùng).
# 2. Tạo folder "credentials" trong thư mục chạy Python (nếu chưa có).
# 3. Lưu nội dung JSON vào file: ${pathForCode}
# 4. Chạy script bên dưới (đường dẫn đã trỏ tới file trên).

# pip install firebase-admin
import firebase_admin
from firebase_admin import credentials, firestore

cred = credentials.Certificate("${pathForCode}")
firebase_admin.initialize_app(cred)
db = firestore.client()

# Đọc 10 document đầu của collection "users" (đổi tên collection nếu cần)
for doc in db.collection("users").limit(10).stream():
    print(doc.id, doc.to_dict())`;
}
